import React from 'react'
import { useStateWiseAccountReport } from "../../hooks/useStateWiseAccountReport";

const Statewisereport = () => {
  const { details, loading, error, getReport } = useStateWiseAccountReport();

  React.useEffect(() => {
    getReport();
  }, [getReport]);

  return (
    <div>
      <h2>Statewise report</h2>
      {loading && <p>Loading...</p>}
      {error && <p>Error: {error}</p>}
      {!loading && !error && (
        <table className="uk-table uk-table-divider uk-custom-table" id="totals">
          <thead>
            <tr>
              <th>State</th>
              <th>Account Count</th>
              <th>Member Count</th>
            </tr>
          </thead>
          <tbody>
            {details?.states?.map((item, index) => (
              <tr key={index}>
                <td>{item.state}</td>
                <td>{item.accountCount}</td>
                <td>{item.memberCount}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  )
}

export default Statewisereport